export enum FieldOverride {
  YesNo = 'YesNo',
  BusinessSizeComponent = 'BusinessSizeComponent',
  BusinessConcepts = 'BusinessConcepts',
  Radio = 'Radio',
}

export type FieldOverrideObject = { [index: string]: FieldOverride };
